import useWebSocket, { Options } from 'react-use-websocket';
import config from '../config';

function heartbeat(uws: ReturnType<typeof useWebSocket>) {
  const interval = 30 * 1000;
  const timeout = 7 * 24 * 60 * 60 * 1000; // 10 * 60 * 1000;
  const message = "ping";

  const pingTimer = setInterval(() => {
    try { uws.sendMessage(message); }
    catch (error) { }
  }, interval);

  const timeoutTimer = setInterval(() => {
    uws.getWebSocket()?.close();
  }, timeout);

  uws.getWebSocket()?.addEventListener("close", () => {
    clearInterval(pingTimer);
    clearInterval(timeoutTimer);
  });
}

export function useAppWebSocket<T>(
  url: string | (() => string | Promise<string>) | null,
  options?: Options | undefined,
  connect?: boolean | undefined
) {
  const uws = useWebSocket(
    `${config.ws.baseUrl}${url}`,
    {
      ...options
    },
    connect
  ) as (ReturnType<typeof useWebSocket> & { lastJsonMessage: T; });

  heartbeat(uws);

  return uws;
}
